import { PageService } from 'src/app/_core/services/page.service';
import { DOCUMENT } from '@angular/common';
import { TipoMovimentacao } from './../../../_core/models/tipo-movimentacao';
import { Page } from './../../../_core/models/page';
import { Movimentacao } from './../../../_core/models/movimentacao';
import { AuthenticationService } from './../../../_core/services/authentication/authentication.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MovimentacaoService } from './../../../_core/services/movimentacao.service';
import { CadastroBemService } from './../../../_core/services/cadastro-bem.service';
import { Usuario } from './../../../_core/models/usuario';
import { Component, OnInit, Inject } from '@angular/core';
import Swal from 'sweetalert2';
import { UploadService } from 'src/app/_core/services/upload.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { TelaDeAprovGestorModalComponent } from './../tela-de-aprov-gestor-modal';

@Component({
  selector: 'app-tela-de-aprov-gestor',
  templateUrl: './tela-de-aprov-gestor.component.html',
  styleUrls: ['./tela-de-aprov-gestor.component.scss']
})
export class TelaDeAprovGestorComponent implements OnInit {
user!:Usuario;
pagina = 1;
total = 10;
page!: Page;
ativo = true;
pesquisa = '';
loading = true;
deletando: boolean = false;
movimentacao: Movimentacao;
mov!:Movimentacao;
tipoMovimentacao!: TipoMovimentacao[];

  constructor(
    private modalService: NgbModal,
    private pageService: PageService,
    private movimentacaoService: MovimentacaoService,
    private uploadService: UploadService,
    @Inject(DOCUMENT) private document: Document) { 

    this.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.ativo = true;
    this.page = new Page();
    this.page.currentPage = this.pagina;
    this.page.pageSize = this.total;
    this.page.ativo = this.ativo;
    this.page.currentPage = 1;
    this.setPage(this.page.currentPage);
    this.MovGetByIdGestor();
  }
  refresh() {
    this.document.location.reload();
  }
  setPage(page: number): void {
    this.loading = true;
    this.page.currentPage = page;
      this.movimentacaoService.mov_listarPageGestor(this.user.cD_MATRICULA,this.page)
      .subscribe(
        data => {
          this.page = data;
          this.page = this.pageService.getPager(this.page);
          this.loading = false;
        },
        err => {
          this.loading = false;
        }
      )

  }
  paginaAtual(pagina: any) {
    return this.page.currentPage === pagina;
  }
  pesquisar() {
    this.page.pesquisa = this.pesquisa;
    this.page.ativo = this.ativo;
    this.page.dados = [];
    this.setPage(1);
  }
  MovGetByIdGestor(){
    this.movimentacaoService.mov_gestor(this.user.cD_MATRICULA)
    .subscribe(
      (data) => {
        this.movimentacao = data;
        //console.log/this.movimentacao)

      }
    )
  }
  listarTipoMovAll() {
    this.movimentacaoService.tipo_mov_getAll()
      .subscribe(
        data => {
          this.tipoMovimentacao = data;
        }
      )
  }
  atualizar() {
    this.pesquisa = '';
    this.ativo = true;
    this.page.dados = [];
    this.pesquisar();
  }
  // uploadEvidencia(files:any){
  //   //console.log/files);
  //   if (files.length === 0){
      
  //     return;
  //   }


  //   const formData = new FormData();

  //   formData.append("file", files[0]);
  // this.uploadService.upload_evidencia(this.movimentacao.nR_BPM_BEM_PATRIMONIAL,formData).subscribe(
  //   (event:HttpEvent<any>) => {
      
  //     if (event.type === HttpEventType.UploadProgress) {
  //       const percentual = Math.round((100 * event.loaded) / (event.total || 0));
  //       //console.log/'Carregando ', percentual)
  //       this.progress = percentual - 50;
        
  //     } else if (event.type === HttpEventType.Response) {
  //       this.progress = 100;
  //       this.message = event.body.message;
  //       Swal.fire(
  //         'Sucesso!',
  //         this.message,
  //         'success'
  //       ).then(() => {
  //         this.atualizar();
  //       });
  //     };
        
  //   });
  // }
  abreEdicao(nR_BPM_BEM_PATRIMONIAL:any){
    //console.log/cD_BPM_BEM_PATRIMONIAL)
    const modalRef = this.modalService.open(TelaDeAprovGestorModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.nR_BPM_BEM_PATRIMONIAL = nR_BPM_BEM_PATRIMONIAL;
    modalRef.result.then(() => this.atualizar());
  }

  aprovar(cD_BPM_BEM_PATRIMONIAL:number) {
    
    Swal.fire({
      title: 'Deseja aprovar esse bem?',
      confirmButtonText: 'Aprovar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      icon: 'info',
    }).then((result)=>{
      if(result.value){
        this.movimentacaoService.insert_aprovar(cD_BPM_BEM_PATRIMONIAL).
        subscribe(
          (data) => {
            //console.log/"AQUI ==> ",data)
            const msg:string = 'Aprovado com sucesso!'
            Swal.fire(
              'Sucesso!',
              msg,
              'success'
            ).then(() => {
              this.atualizar();
            });
          },
          (err) => {
            //console.log/JSON.stringify(err))
            let msg:string = 'Erro ao aprovar,tente novamente mais tarde!'
            if(err.status == 401){
              return msg = err.error;
            }
            Swal.fire('Erro',msg,'error').then(()=>{
              this.loading = false;
            });
          }
        )
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.deletando = false;
        this.loading = false;
      }
        
    })
  }
  // reprovar(cD_BPM_BEM_PATRIMONIAL:number) {
    
  //   Swal.fire({
  //     title: 'Deseja reprovar esse bem?',
  //     confirmButtonText: 'Reprovar',
  //     showCancelButton: true,
  //     cancelButtonText: 'Cancelar',
  //     icon: 'info',
  //   }).then((result)=>{
  //     if(result.value){
  //       this.movimentacaoService.insert_reprovar(cD_BPM_BEM_PATRIMONIAL).
  //       subscribe(
  //         data => {
  //           const msg:string = 'Reprovado com sucesso!'
  //           Swal.fire(
  //             'Sucesso!',
  //             msg,
  //             'success'
  //           ).then(() => {
  //             this.atualizar();
  //           });
  //         },
  //         err => {
  //           //console.log/JSON.stringify(err))
  //           let msg:string = 'Erro ao reprovar,tente novamente mais tarde!'
  //           if(err.status == 401){
  //             return msg = err.error;
  //           }
  //           Swal.fire('Erro',msg,'error').then(()=>{
  //             this.loading = false;
  //           });
  //           //console.log/JSON.stringify(err))
  //         }
  //       )
  //     }
  //   })
  // }
}
